export default __webpack_public_path__ + "static/media/img (2).ac171044.jpg";